module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row4_googleQRcode.47a2ec1e.png";